import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './ForgotPassword.css';

export default function ResetPassword() {
  const { language } = useLanguage();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const text = language === 'zh' ? {
    title: '重置密码',
    desc: '请输入新密码。提交后可以直接用新密码登录。',
    password: '新密码',
    confirm: '确认新密码',
    missingToken: '重置链接无效或缺少 token，请重新发起忘记密码。',
    invalidPassword: '密码需为 8-128 位',
    mismatch: '两次输入的密码不一致',
    failed: '重置失败，请重新申请重置链接',
    submitting: '提交中...',
    submit: '更新密码',
    successTitle: '密码已重置',
    successText: '请返回登录页，使用新密码登录。',
    back: '返回登录',
  } : {
    title: 'Reset password',
    desc: 'Enter a new password. After saving, sign in with the new password.',
    password: 'New password',
    confirm: 'Confirm new password',
    missingToken: 'This reset link is invalid or missing a token. Please request a new link.',
    invalidPassword: 'Password must be 8-128 characters',
    mismatch: 'Passwords do not match',
    failed: 'Reset failed. Please request a new link.',
    submitting: 'Submitting...',
    submit: 'Update password',
    successTitle: 'Password reset',
    successText: 'Return to sign in and use your new password.',
    back: 'Back to login',
  };
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(token ? '' : text.missingToken);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError(text.missingToken);
      return;
    }
    if (password.length < 8 || password.length > 128) {
      setError(text.invalidPassword);
      return;
    }
    if (password !== confirmPassword) {
      setError(text.mismatch);
      return;
    }

    setLoading(true);
    try {
      await api.post('/users/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || text.failed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fpw-page">
      <div className="fpw-card">
        <h1>{text.title}</h1>

        {!done ? (
          <>
            <p className="fpw-desc">{text.desc}</p>
            <form onSubmit={onSubmit}>
              <label>{text.password}</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              <label className="fpw-label-spaced">{text.confirm}</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              {error && <div className="fpw-err">{error}</div>}
              <button type="submit" className="btn btn-primary" disabled={loading || !token}>
                {loading ? text.submitting : text.submit}
              </button>
            </form>
          </>
        ) : (
          <div className="fpw-success">
            <div className="fpw-check">✓</div>
            <h3>{text.successTitle}</h3>
            <p>{text.successText}</p>
          </div>
        )}

        <div className="fpw-footer">
          <Link to="/login">← {text.back}</Link>
        </div>
      </div>
    </div>
  );
}
